(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope=document) {
    scope.querySelectorAll('[data-deadline]').forEach(el => {
      if(el.dataset.ready) return; el.dataset.ready='1';
      const end = Date.parse(el.dataset.deadline);
      if(!Number.isFinite(end)) return;
      const tick=()=>{ const left=end-Date.now(); if(left<=0){el.hidden=true;return false;}
        const s=Math.floor(left/1000),d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60);
        el.querySelector('[data-clock]').textContent=`${d}d ${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;el.hidden=false;return true;};
      if(tick()){const id=setInterval(()=>{if(!el.isConnected||!tick())clearInterval(id);},1000);}
    });
    scope.querySelectorAll('[data-video-toggle]').forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='1';
      const video=button.closest('.hero').querySelector('video'); if(!video)return;
      const ar=document.documentElement.lang.startsWith('ar');
      const sync=()=>{button.textContent=video.paused?(ar?'تشغيل الفيديو':'Play video'):(ar?'إيقاف الفيديو مؤقتاً':'Pause video');button.setAttribute('aria-pressed',String(video.paused));};
      if(reduced.matches)video.pause();sync();video.addEventListener('play',sync);video.addEventListener('pause',sync);
      button.addEventListener('click',()=>{if(video.paused)video.play().catch(sync);else video.pause();});
    });
    scope.querySelectorAll('[data-product-section]').forEach(el=>{
      if(el.dataset.ready)return;el.dataset.ready='1';
      const data=el.parentElement.querySelector('[data-variants]');if(!data)return;
      let variants;try{variants=JSON.parse(data.textContent);}catch{return;}
      const select=el.querySelector('[data-variant]');if(!select)return;
      select.addEventListener('change',()=>{
        const v=variants.find(v=>String(v.id)===select.value);if(!v)return;
        el.querySelector('[data-price]').textContent=v.price;
        const compare=el.querySelector('[data-compare]');compare.textContent=v.compare;compare.hidden=!v.sale;
        const add=el.querySelector('[data-add]');add.disabled=!v.available;add.textContent=v.available?add.dataset.available:add.dataset.sold;
        const q=el.querySelector('[data-quantity]');q.min=v.min;q.step=v.step;q.value=v.min;if(v.max)q.max=v.max;else q.removeAttribute('max');
        const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
        const media=el.querySelector(`[id$="-${v.image}"]`);if(media)media.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'nearest'});
      });
    });
  }
  document.addEventListener('click',e=>{document.querySelectorAll('.navigation details[open]').forEach(d=>{if(!d.contains(e.target))d.open=false;});});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.navigation details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  init();
})();
